<template>
  <div class="payment-result-container">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <p>正在验证您的支付...</p>
    </div>

    <!-- 成功状态 -->
    <div v-else-if="status === 'succeeded'" class="result success">
      <div class="icon-container">
        <i class="success-icon">✓</i>
      </div>
      <h1>支付成功！</h1>
      <p>感谢您的订购，您的支付已完成。</p>
      <p class="details">订单号: {{ orderId }}</p>
      <p class="details">金额: {{ formatAmount(amount) }}</p>
      <div class="buttons">
        <button class="btn secondary" @click="continueShopping">继续支付</button>
        <!--<button class="btn primary" @click="viewOrder">查看订单</button>
        <button class="btn secondary" @click="continueShopping">继续购物</button>-->
      </div>
    </div>

    <!-- 处理中状态 -->
    <div v-else-if="status === 'processing'" class="result processing">
      <div class="icon-container">
        <i class="processing-icon">⟳</i>
      </div>
      <h1>支付处理中</h1>
      <p>您的付款正在处理中，这可能需要一些时间。</p>
      <p class="details">我们会通过邮件通知您支付结果。</p>
      <div class="buttons">
        <button class="btn secondary" @click="goToAccount">返回账户</button>
      </div>
    </div>

    <!-- 失败状态 -->
    <div v-else-if="status === 'failed'" class="result failed">
      <div class="icon-container">
        <i class="failed-icon">✕</i>
      </div>
      <h1>支付失败</h1>
      <p>很抱歉，您的支付未能完成。</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <div class="buttons">
        <button class="btn primary" @click="retryPayment">重新支付</button>
        <button class="btn secondary" @click="contactSupport">联系客服</button>
      </div>
    </div>

    <!-- 其他错误状态 -->
    <div v-else class="result error">
      <div class="icon-container">
        <i class="error-icon">!</i>
      </div>
      <h1>出现问题</h1>
      <p>处理您的支付请求时遇到了问题。</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <div class="buttons">
        <button class="btn primary" @click="goToCheckout">返回结账</button>
        <button class="btn secondary" @click="contactSupport">联系客服</button>
      </div>
    </div>
  </div>
</template>

<script>
    import { loadStripe } from '@stripe/stripe-js';
    import { config } from '@/utils/config';
    import {Form, Message} from 'element-ui';
export default {
  data() {
    return {
      loading: true,
      status: '',
      errorMessage: '',
      currency:'',
      amount: 0,
      orderId: '',
      paymentIntentId: '',
      clientSecret: ''
    };
  },
  
  created() {
    // 从URL获取支付参数
    const urlParams = new URLSearchParams(window.location.search);
    this.paymentIntentId = urlParams.get('payment_intent');
    this.clientSecret = urlParams.get('payment_intent_client_secret');
    const redirectStatus = urlParams.get('redirect_status');
    
    // 初始状态可以从URL中的redirect_status参数获取
    if (redirectStatus) {
      this.status = redirectStatus;
    }
    
    // 验证支付状态
    this.verifyPayment();
  },
  
  methods: {
    async verifyPayment() {
      if (!this.paymentIntentId || !this.clientSecret) {
        this.status = 'error';
        this.errorMessage = '缺少支付信息';
        this.loading = false;
        return;
      }
      
      try {
        // 先用客户端SDK验证支付状态
       // const stripe = loadStripe(config.stripeApiPublicKey);
        //const { paymentIntent } = await stripe.retrievePaymentIntent(this.clientSecret);
        
        let data = {};
       
          this.getRequest('/stripe/'+this.paymentIntentId).then(resp =>{
              self.payBtn=false;
              if(resp.code >= 0){
                Message.error({message: resp.msg});
                return;
              }
              console.log(resp.data);
              const paymentIntent = resp.data;
               // 获取初步状态
                this.status = paymentIntent.status;
                this.amount = paymentIntent.amount;
                this.currency = paymentIntent.currency;
                // 如果看起来支付成功，再向服务器进行验证
                if (this.status === 'succeeded' || this.status === 'processing') {
                 this.verifyWithServer();
                } else {
                this.errorMessage = this.getErrorMessage(paymentIntent);
                this.loading = false;
                }
        })

       
      } catch (error) {
        console.error('验证支付失败:', error);
        this.status = 'error';
        this.errorMessage = `验证过程中出错: ${error.message}`;
        this.loading = false;
      }
    },
    
    async verifyWithServer() {
      try {
        let data = {};
        data.paymentIntentId = this.paymentIntentId;
          this.postRequest('/stripe/verify',data).then(resp =>{
              self.payBtn=false;
              if(resp.err >= 500){
                Message.error({message: resp.msg});
                return;
              }
              console.log(resp.data);
        })
      } catch (error) {
        console.error('服务器验证失败:', error);
        this.status = 'error';
        this.errorMessage = '服务器验证过程中出错';
      } finally {
        this.loading = false;
      }
    },
    
    formatAmount(amount) {
      // 将Stripe金额（以分为单位）转换为带货币符号的金额
      const formatter = new Intl.NumberFormat('zh-CN', {
        style: 'currency',
        currency: this.currency, // 根据您的货币更改
      });
      
      return formatter.format(amount / 100);
    },
    
    getErrorMessage(paymentIntent) {
      // 根据PaymentIntent的last_payment_error获取错误信息
      if (paymentIntent.last_payment_error) {
        return paymentIntent.last_payment_error.message;
      }
      
      // 根据状态提供默认错误消息
      switch (paymentIntent.status) {
        case 'requires_payment_method':
          return '支付方式被拒绝，请尝试其他支付方式';
        case 'requires_action':
          return '需要额外的验证步骤';
        default:
          return '支付过程中出现问题';
      }
    },
    continueShopping(){
        this.$router.push('/');
    },
    // 导航方法
    viewOrder() {
      this.$router.push(`/account/orders/${this.orderId}`);
    },
    
    goToAccount() {
      this.$router.push('/account');
    },
    
    retryPayment() {
      this.$router.push('/checkout');
    },
    
    contactSupport() {
      this.$router.push('/contact');
    },
    
    goToCheckout() {
      this.$router.push('/checkout');
    }
  }
};
</script>

<style scoped>
.payment-result-container {
  max-width: 600px;
  margin: 50px auto;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #5469d4;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.result {
  padding: 20px 0;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.success-icon,
.processing-icon,
.failed-icon,
.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 30px;
}

.success-icon {
  background-color: #0A6E0A;
  color: white;
}

.processing-icon {
  background-color: #B76E00;
  color: white;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  100% { transform: rotate(360deg); }
}

.failed-icon, .error-icon {
  background-color: #DF1B41;
  color: white;
}

h1 {
  margin-bottom: 15px;
  font-size: 24px;
}

p {
  margin-bottom: 10px;
  color: #4a4a4a;
}

.details {
  margin-top: 20px;
  font-weight: bold;
}

.error-message {
  color: #DF1B41;
  margin-top: 15px;
  padding: 10px;
  background-color: #ffeeee;
  border-radius: 4px;
}

.buttons {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.btn {
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn.primary {
  background-color: #5469d4;
  color: white;
}

.btn.primary:hover {
  background-color: #4a5dc9;
}

.btn.secondary {
  background-color: #f7f8fa;
  color: #5469d4;
  border: 1px solid #e0e0e0;
}

.btn.secondary:hover {
  background-color: #e6e9f1;
}

.success { color: #0A6E0A; }
.processing { color: #B76E00; }
.failed, .error { color: #DF1B41; }
</style>